import LockSondertagDialog from "./LockSondertagDialog";
import AddSonderEventDialog from "./AddSonderEventDialog";
import AddSondertagDialog from "./AddSondertagDialog";
import AddJobDialog from "./AddJobDialog";

function SondertageDialogs({
  dialogs,
  actions,
  selectedSchoolyear,
  schoolyears,
  sondertagTemplates,
  sonderEventTemplates,
  sondertage,
}) {
  return (
    <>
      {/* ✅ LOCK */}
      <LockSondertagDialog
        open={dialogs.lockDialogOpen}
        onClose={() => dialogs.setLockDialogOpen(false)}
        onConfirm={actions.handleToggleLock}
      />

      {/* ✅ EVENT */}
      <AddSonderEventDialog
        open={dialogs.createSonderEventOpen}
        onClose={() => {
          dialogs.setCreateSonderEventOpen(false);
          dialogs.setEditingSonderEvent(null); // ✅ reset
        }}
        onSave={async (data) => {
          const created = await actions.handleSaveSonderEvent(
            data,
            dialogs.editingSonderEvent,
          );
          dialogs.closeCreateSonderEvent();
        }}
        selectedSchoolyear={selectedSchoolyear}
        schoolyears={schoolyears}
        initialData={dialogs.editingSonderEvent}
        sonderEventTemplates={sonderEventTemplates}
      />

      {/* ✅ SONDERTAG */}
      <AddSondertagDialog
        open={dialogs.createSondertagOpen}
        onClose={() => {
          dialogs.setCreateSondertagOpen(false);
          dialogs.setEditingSondertag(null); // ✅ reset
        }}
        onSave={(data) =>
          actions.handleSaveSondertag(data, dialogs.editingSondertag)
        }
        initialData={dialogs.editingSondertag}
        sondertagTemplates={sondertagTemplates}
      />

      {/* ✅ JOB */}
      <AddJobDialog
        open={dialogs.createJobOpen}
        onClose={() => {
          dialogs.setCreateJobOpen(false);
          dialogs.setEditingJob(null); // ✅ reset
        }}
        onSave={(data) => actions.handleSaveJahrgang(data, dialogs.editingJob)}
        sondertage={sondertage}
        initialData={
          dialogs.editingJob
            ? {
                id: dialogs.editingJob.id,
                dayId: dialogs.editingJob.angebote.length
                  ? dialogs.editingJob.angebote[0].sondertagId
                  : null,
                title: dialogs.editingJob.title,
                klassenSlots:
                  Math.ceil(dialogs.editingJob.angebote?.length / 2) ?? 3,
              }
            : null
        }
      />
    </>
  );
}

export default SondertageDialogs;
